import { useTranslationContext } from "./TranslationContext";

export function useTranslation() {
	const { t, lang, setLang, isLoading, error } = useTranslationContext();
	return { t, lang, setLang, isLoading, error };
}
